/**
 * Date-extensions locale German [de]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('de', {
    monthNames: ['Januar','Februar','März','April','Mai','Juni','Juli','August','September','Oktober','November','Dezember'],
    monthShortNames: ['Jan.','Febr.','Mrz.','Apr.','Mai','Jun.','Jul.','Aug.','Sept.','Okt.','Nov.','Dez.'],
    dayNames: ['Sonntag','Montag','Dienstag','Mittwoch','Donnerstag','Freitag','Samstag'],
    dayShortNames: ['So.','Mo.','Di.','Mi.','Do.','Fr.','Sa.']
});
